import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import type { ServiceChoiceWithEpisodeCategory } from './schemas/choiceSchema';
import { serviceChoiceWithEpisodeCategorySchema } from './schemas/choiceSchema';

export interface IFinancialExportValidated {
    endDate: string | null;
    episodeCategoryId: string | null;
    serviceChoice: ServiceChoiceWithEpisodeCategory;
    serviceId: string | null;
    startDate: string | null;
}

export const financialExportSchema: ISchemaContainer<IFinancialExportValidated> = {
    schema: Koi.object({
        endDate: Koi.koi().endDate().date(),
        episodeCategoryId: Koi.when('serviceChoice', {
            is: 'episodeCategory',
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.string().uuid(),
        }),
        serviceChoice: serviceChoiceWithEpisodeCategorySchema,
        serviceId: Koi.when('serviceChoice', {
            is: 'specific',
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.string().uuid(),
        }),
        startDate: Koi.koi().date(),
    }).options({ convert: false, presence: 'required' }),
};
